import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=2075c828"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2075c828')) {
      api.createRecord('2075c828', component.options)
    } else {
      api.reload('2075c828', component.options)
    }
    module.hot.accept("./chat.vue?vue&type=template&id=2075c828", function () {
      api.rerender('2075c828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/chat.vue"
export default component.exports